/** @format */

import RPIS from "assets/images/products/reactive-power-improvement-solution/RPIS.svg";
import NoiseCutTransformer from "assets/images/products/power-quality/noise-cut-transformer.svg";
import HarmonicReductionSolution from "assets/images/products/power-quality/harmonic-reduction-solution.png";
import CustomizableSolutions from "assets/images/home/solutions/customizable-solutions.png";
import SolarPower from "assets/images/home/solutions/solar-power.png";
import ILPMS from "assets/images/home/solutions/ilpms.png";
import SurgeInfo from "assets/images/home/solutions/surge-info.png";
import Surge from "assets/images/home/solutions/surge.png";
import NoiseFilter from "assets/images/products/power-quality/noise-filter.png";
import ZeroSequenceHarmonicFilter from "assets/images/products/power-quality/zero-sequence-harmonic-filter.png";
import ActiveHarmonicFilter from "assets/images/products/power-quality/paf.png";
import StaticVarCompensator from "assets/images/products/power-quality/static-var-compensator.png";
import StaticVarGenerator from "assets/images/products/power-quality/static-var-generator.png";
import SpdForPowerImg from "assets/images/products/spd/spd-for-power.png";
import SgSeriesImg from "assets/images/products/spd/sg-series.png";
import RSeriesImg from "assets/images/products/spd/r-series.png";
import SbSeriesImg from "assets/images/products/spd/sb-series.png";
import PsSeriesImg from "assets/images/products/spd/ps-series.png";
import TpsSeriesImg from "assets/images/products/spd/tps-series.png";

export const SPD_MENU = {
  SPD: {
    name: "SPD",
    koreanName: "서지 보호",
    key: "spd",
  },
  SPD_FOR_POWER: {
    name: "SPD for Power",
    koreanName: "전원용 SPD",
    key: "spd-for-power",
    img: SpdForPowerImg,
  },
  R_SERIES: {
    name: "R Series",
    koreanName: "철재외함 전선인출형 (R 시리즈)",
    key: "r-series",
    img: RSeriesImg,
  },
  SB_SERIES: {
    name: "SB+ Series",
    koreanName: "철재외함 개방교체형 (SB+ 시리즈)",
    key: "sb+-series",
    img: SbSeriesImg,
  },
  SG_SERIES: {
    name: "SG Series",
    koreanName: "철재외함 단자접속형 (SG 시리즈)",
    key: "sg-series",
    img: SgSeriesImg,
  },
  PS_SERIES: {
    name: "PS Series",
    koreanName: "수지외함 (PS 시리즈)",
    key: "ps-series",
    img: PsSeriesImg,
  },
  PS_DC_SERIES: {
    name: "PS(DC) Series",
    koreanName: "수지외함 (PS(DC) 시리즈)",
    key: "ps-dc-series",
    img: PsSeriesImg,
  },
  SPD_EXTERNAL_DISCONNECTOR: {
    name: "SPD External Disconnector",
    koreanName: "SPD 외부분리기 (TPS 시리즈)",
    key: "spd-external-disconnector",
    img: TpsSeriesImg,
  },
  SPD_FOR_COMMUNICATION: {
    name: "SPD for Communication",
    koreanName: "신호 & 통신용 SPD",
    key: "spd-for-communication",
  },
  SPD_EXTRA: {
    name: "SPD Extra",
    koreanName: "기타",
    key: "spd-extra",
  },
};
export const POWER_QUALITY_MENU = {
  // ------- 전력 품질 ---------
  POWER_QUALITY: {
    name: "Power Quality",
    koreanName: "전력 품질",
    key: "power-quality",
  },
  HARMONIC_REDUCTION_SOLUTION: {
    name: "Harmonic Reduction Solution",
    koreanName: "고조파 저감 솔루션",
    key: "harmonic-reduction-solution",
    img: HarmonicReductionSolution,
  },
  ACTIVE_HARMONIC_FILTER: {
    name: "Active Harmonic Filter",
    koreanName: "능동 고조파 필터 (PAF 시리즈)",
    key: "active-harmonic-filter",
    img: ActiveHarmonicFilter,
    detail:
      "능동형 고조파 필터(AHF)는 부하 전류의 고조파 성분을 역위상 전류를 통해 제거하며, 고조파 차수, 크기, 설치 위치에 관계없이 효과적입니다. 또한 역률 개선과 3상 4선 배전 시스템의 불평형 부하 전류 개선을 통해 산업 현장에서 전력 품질 향상을 위한 최적의 솔루션을 제공합니다.",
  },
  ZERO_SEQUENCE_HARMONIC_FILTER: {
    name: "Zero Sequence Harmonic Filter",
    koreanName: "영상 고조파 필터 (PZF 시리즈)",
    key: "zero-sequence-harmonic-filter",
    img: ZeroSequenceHarmonicFilter,
    detail:
      "UPS, 인버터, PC, 조명기기 등의 비선형 부하에서 발생하는 고조파는 전력 계통으로 유입되어 전기 기기의 오동작과 수명 감소를 초래합니다. 특히 영상 고조파는 중성선(N상)에 중첩되어 중성선의 과열(화재 위험)과 소음 발생 기기의 철손 증가 등 전력 설비에 악영향을 끼치므로, 분전반에 영상 고조파 필터를 설치하여 네트워크를 구성함으로써 전력 품질을 효과적으로 개선합니다.",
  },
  //------------------------------------------------
  REACTIVE_POWER_IMPROVEMENT_SOLUTION: {
    name: "Reactive Power Improvement Solution",
    koreanName: "무효전력 개선 솔루션",
    key: "reactive-power-improvement-solution",
    img: RPIS,
  },
  STATIC_VAR_GENERATOR: {
    name: "Static Var Generator",
    koreanName: "정지형 동기식 무효전력 보상장치 (LV-STATCOM)",
    key: "static-var-generator",
    img: StaticVarGenerator,
    detail:
      "전자식 무효전력발생장치(PSVG 시리즈)는 부하변동에 따라 고속으로 IGBT 전력소자에 의한 PWM제어로 진상 및 지상 무효전력을 보상합니다.",
  },
  PSVG_SERIES: {
    name: "PSVG Series",
    koreanName: "일반형 (PSVG 시리즈)",
    key: "psvg-series",
    img: StaticVarGenerator,
  },
  PSTA_SERIES: {
    name: "PSTA Series",
    koreanName: "고급형 (PSTA 시리즈)",
    key: "psta-series",
    img: StaticVarGenerator,
  },
  STATIC_VAR_COMPENSATOR: {
    name: "Static Var Compensator",
    koreanName: "정지형 무효전력 보상장치 (PSVC 시리즈)",
    key: "static-var-compensator",
    img: StaticVarCompensator,
    detail:
      "정지형 무효전력 보상장치(PSVC 시리즈)는 사이리스터를 이용하여 병렬콘덴서와 분로리액터를 신속하게 접속제어하여 무효전력 및 전압을 제어하는 장치로서 역률개선용 Capacitor크기를 세분화하고 Capacitor 개폐스위치를 반도체소자 SCR zero crossing제어를 통하여 기존 static capacitor성능을 개선한 실시간(4~20ms) 무효전력보상을 하는 장치입니다.",
  },
  //------------------------------------------------
  NOISE_REDUCTION_SOLUTION: {
    name: "Noise Reduction Solution",
    koreanName: "노이즈 저감 솔루션",
    key: "noise-reduction-solution",
    img: NoiseCutTransformer,
  },
  NOISE_FILTER: {
    name: "Noise Filter",
    koreanName: "노이즈 필터 (PLF 시리즈)",
    key: "noise-filter",
    img: NoiseFilter,
    detail:
      "노이즈 필터(PLF 시리즈)는 선로 및 접지로 유입되는 전도성 노이즈를 억제하여 전원 및 통신기기 피해를 최소화하는 장치",
    product: {
      name: "Power Line Noise Filter",
    },
  },
  NOISE_CUT_TRANSFORMER: {
    name: "Noise Cut Transformer",
    koreanName: "노이즈 차폐 변압기 (PTR 시리즈)",
    key: "noise-cut-transformer",
    img: NoiseCutTransformer,
    detail:
      "NCT 는 트랜스의 일반적인 기능인 전압의 승,강압 보다는 노이즈의 차단을 목적으로 개발된 변압기의 일종",
  },
  //------------------------------------------------
};
export const SOLUTION_MENU = {
  SURGE_INFO: {
    name: "Surge Info",
    koreanName: "서지의 개요",
    key: "surge-info",
    img: SurgeInfo,
  },
  SPD_COORDINATION: {
    name: "SPD Coordination",
    koreanName: "서지 보호 장치 (SPD)",
    key: "spd-coordination",
    img: Surge,
  },
  RENEWABLE_ENERGY_PROTECTION: {
    name: "Protection of Renewable Energy (Solar, Wind, ESS) Equipment",
    koreanName: "신재생 (태양광, 풍력, ESS) 설비 보호",
    key: "renewable-energy-protection",
    img: SolarPower,
  },
  HARMONIC_SOLUTION: {
    name: "Harmonic Reduction Solution",
    koreanName: "고조파 저감 솔루션",
    key: "harmonic-solution",
    img: HarmonicReductionSolution,
  },
  REACTIVE_POWER_SOLUTION: {
    name: "Reactive Power Improvement Solution",
    koreanName: "무효전력 개선 솔루션",
    key: "reactive-power-solution",
    img: RPIS,
  },
  SLPMS: {
    name: "SLPMS",
    koreanName: "피뢰 관리 시스템 (SLPMS)",
    key: "SLPMS",
    img: ILPMS,
  },
};
export const SERVICE_MENU = {
  PRODUCT_INQUIRY: {
    name: "Product Inquiry",
    koreanName: "제품 문의",
    key: "product-inquiry",
  },
  INFORMATION_REQUEST: {
    name: "Information Request",
    koreanName: "자료 요청",
    key: "information-equest",
  },
  QUOTATION: {
    name: "quote request",
    koreanName: "견적 요청",
    key: "quote-request",
  },
  PURCHASE: {
    name: "Purchase",
    koreanName: "구매 요청",
    key: "purchase",
  },
};
export const CONTACT_MENU = {
  CEO_GREETING: {
    name: "Greetings",
    koreanName: "인사말",
    key: "greeting",
  },
  LOCATION: {
    name: "Location",
    koreanName: "찾아 오시는 길",
    key: "location",
  },
  HISTORY: {
    name: "History",
    koreanName: "연혁",
    key: "history",
  },
  CUSTOMERS: {
    name: "Customers",
    koreanName: "주요 고객사",
    key: "customers",
  },
  ABOUT_COMPANY: {
    name: "About Company",
    koreanName: "회사 기본정보",
    key: "about-company",
  },
  NEWS: {
    name: "News",
    koreanName: "뉴스",
    key: "news",
  },
  NEWS_DETAIL: {
    name: "News Detail",
    koreanName: "뉴스 상세",
    key: "news-detail",
  },
  VIDEOS: {
    name: "Videos",
    koreanName: "홍보 동영상",
    key: "videos",
  },
  ORGANIZATION: {
    name: "Organization",
    koreanName: "조직도",
    key: "organization",
  },
};
export const RESOURCE_MENU = {
  CATALOGS: {
    name: "Catalog",
    koreanName: "카달로그",
    key: "catalog",
  },
  CERTIFICATE: {
    name: "Certificate",
    koreanName: "인증서",
    key: "certificate",
  },
  CERTIFICATE_DETAIL: {
    name: "Certificate Detail",
    koreanName: "인증서 상세",
    key: "certificate-detail",
  },
  CREATE_DOC: {
    name: "Create Doc",
    koreanName: "문서 작성",
    key: "create-doc",
  },
  PRE_QUALIFICATIONS: {
    name: "Pre-Qualifications",
    koreanName: "지명원",
    key: "pre-qualifications",
  },
  PATENT: {
    name: "Patent",
    koreanName: "특허",
  },
};
export const CUSTOMER_SUPPORT_MENU = {
  INQUIRY: {
    name: "Inquiry",
    koreanName: "견적 및 문의",
    key: "inquiry",
  },
  QUOTE: {
    name: "Quotes",
    koreanName: "제품 발주",
    key: "quotes",
  },
};
export const MENU_NAMES = {
  PRODUCTS: { koreanName: "제품", englishName: "Products", key: "products" },
  // 「기술 정보」는 상단 메뉴에서 제외되었으나, 라우팅과 페이지 타이틀에서
  // 계속 사용되므로 상수 자체는 유지한다.
  SOLUTIONS: {
    koreanName: "기술 정보",
    englishName: "Technical Info",
    key: "solutions",
  },
  CUSTOMER_SUPPORT: {
    koreanName: "문의",
    englishName: "Inquiry",
    key: "customer-support",
  },
  CONTACT: { koreanName: "회사소개", englishName: "About Us", key: "contact" },
  RESOURCES: { koreanName: "자료실", englishName: "Download", key: "resource" },
};

export const SURGE_INFO_MENU = {
  TYPES: { name: "Type of Surges", koreanName: "서지의 종류", key: "Surge" },
  INFLOW: {
    name: "Inflow Path of Surge",
    koreanName: "서지의 유입 경로",
  },
  WAVEFORM: {
    name: "Surge Voltage & Current Waveform",
    koreanName: "서지의 전압 전류 파형",
  },
  LOGISTICS: {
    name: "Relevant Legislation Standard",
    koreanName: "관련 법령기준",
  },
  LOCATION: {
    name: "Rating criteria based on SPD installation location",
    koreanName: "SPD 설치 위치에 따른 등급 기준",
  },
  CAPACITY: {
    name: "SPD's Capacity Calculation Criteria",
    koreanName: "SPD의 용량 선정 기준",
  },
};

export const HARMONIC_MENU = {
  WHAT_IS_HARMONIC: {
    name: "What are Harmonics",
    koreanName: "고조파란?",
  },
  REGULATIONS: {
    name: "Regulations & Standards",
    koreanName: "관련 규정",
  },
  SMART_PQ_PACK: {
    name: "Smart-PQ Pack",
    koreanName: "Smart-PQ Pack",
  },
};

export const REACTIVE_POWER_MENU = {
  REACTIVE_POWER_BASICS: {
    name: "Reactive Power & Power Factor",
    koreanName: "무효전력, 역률?",
  },
  POWER_CHARACTERISTICS: {
    name: "Recent Power Characteristics",
    koreanName: "최근의 전력 특성",
  },
  SMART_PQ_PACK: {
    name: "Smart-PQ Pack",
    koreanName: "Smart-PQ Pack",
  },
};

export const HOME_BOX_MENU = {
  SG_SERIES: {
    name: "SG Series",
    koreanName: "SG 시리즈",
    path: "/products/spd/spd-for-power/sg-series",
    img: SurgeInfo,
  },
  SPD_FOR_COMMUNICATION: {
    name: "SPD for Communication",
    koreanName: "신호 & 통신용 SPD",
    path: "/products/spd/spd-for-communication",
    img: Surge,
  },
  ACTIVE_HARMONIC_FILTER: {
    name: "Active Harmonic Filter",
    koreanName: "능동 고조파 필터",
    path: "/products/power-quality/harmonic-reduction-solution/active-harmonic-filter",
    img: SurgeInfo,
  },
  ZERO_SEQUENCE_HARMONIC_FILTER: {
    name: "Zero Sequence Harmonic Filter",
    koreanName: "영상 고조파 필터",
    path: "/products/power-quality/harmonic-reduction-solution/zero-sequence-harmonic-filter",
    img: SolarPower,
  },
  PSVG_SERIES: {
    name: "PSVG Series",
    koreanName: "PSVG 시리즈",
    path: "/products/power-quality/reactive-power-improvement-solution/static-var-generator/psvg-series",
    img: Surge,
  },
  PSTA_SERIES: {
    name: "PSTA Series",
    koreanName: "PSTA 시리즈",
    path: "/products/power-quality/reactive-power-improvement-solution/static-var-generator/psta-series",
    img: SolarPower,
  },
  PLF_SERIES: {
    name: "PLF Series",
    koreanName: "PLF 시리즈",
    path: "/products/power-quality/noise-reduction-solution/noise-filter",
    img: CustomizableSolutions,
  },
};
